// @flow
import { addImageQueryParams, getSellerUrl } from '../../utils/urls';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import type { Seller } from '@liveauctioneers/flow-types/lib/Seller';
import styles from './ConsignmentAd.module.scss';

type AdUnit = {
    adUnitId: number,
    consignment: boolean,
    imageUrl1: string,
    seller: Seller,
};

type Props = {
    adUnit: AdUnit,
    className: string,
    trackClick: Function,
};

const ConsignmentAd = (props: Props) => {
    const { adUnit, className, trackClick } = props;
    const { imageUrl1, seller } = adUnit;
    const { sellerId, name: sellerName } = seller;

    return (
        <div className={styles.wrapper} onClick={trackClick}>
            <div className={`${styles.ad}${className ? ` ${className}` : ''}`}>
                <Link route to={`${getSellerUrl(sellerId, sellerName)}?consign=true`}>
                    <ImageWithFallback className={styles.image} src={addImageQueryParams(imageUrl1)} alt={sellerName} />
                </Link>
            </div>
        </div>
    );
};

export default React.memo<Props>(ConsignmentAd, isEqual);
